import "animate.css";
import React from "react";
import { useInView } from "react-intersection-observer";
import styled from "styled-components";

const WhyChooseEonX = () => {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.0 });

    return (
        <Wrapper ref={ref}
            className={`container ${inView ? "animate__animated animate__slideInRight" : "opacity-0"}`}>
            <Section>
                <Title className="font40 extraBold animated-gradient-text">Why Choose EonX?
                </Title>

                <PillarsGrid>
                    <Pillar>
                        <Icon>📡</Icon>
                        <PillarTitle className="animated-gradient-text">Scalable & Future-Ready Solutions</PillarTitle>
                        <PillarText className="font13">
                            Building scalable, tech-driven solutions that power businesses to new heights.
                        </PillarText>
                    </Pillar>
                    <Pillar>
                        <Icon>🎨</Icon>
                        <PillarTitle className="animated-gradient-text">Technology Meets Creativity</PillarTitle>
                        <PillarText className="font13">
                            Seamlessly blending innovation and design to create stunning digital experiences.
                        </PillarText>
                    </Pillar>
                    <Pillar>
                        <Icon>📊</Icon>
                        <PillarTitle className="animated-gradient-text">Long-Term Impact & Growth</PillarTitle>
                        <PillarText className="font13">
                            We focus on sustainable solutions that drive exponential business growth.
                        </PillarText>
                    </Pillar>
                    <Pillar>
                        <Icon>🏅</Icon>
                        <PillarTitle className="animated-gradient-text">Innovation Rooted in Excellence</PillarTitle>
                        <PillarText className="font13">
                            Pushing boundaries with advanced technology and groundbreaking ideas.
                        </PillarText>
                    </Pillar>
                </PillarsGrid>
            </Section>


        </Wrapper>
    );
};

export default WhyChooseEonX;

const Wrapper = styled.div`
  max-width: 1200px;
  margin: auto;
  padding: 60px 20px;
`;

const Section = styled.div`
  margin-bottom: 50px;
`;

const Title = styled.h2`
  text-align: left;
  margin-bottom: 20px;
`;

const PillarsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
`;

const Pillar = styled.div`
  padding: 20px;
  border-radius: 10px;
  text-align: left;
`;

const Icon = styled.div`
  font-size: 28px;
  margin-bottom: 10px;
`;

const PillarTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const PillarText = styled.p`
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
`;

const ListItem = styled.li`
  font-size: 16px;
  margin-bottom: 10px;
`;

const FooterText = styled.p`
  margin-top: 20px;
  font-size: 14px;
  color: #777;
`;
